// MedicalHero.jsx
import React from "react";

export default function HeroCard8() {
    
  return (
    <>
    <section className="vh-hero">

        {/* Floating hex shapes */}
        <div className="vh-hex h1"><svg className="vh-stroke-icon" width="140" height="140" viewBox="0 0 140 140">
              <path
                d="M40 70 L60 70 L60 50 L80 50 L80 70 L100 70 L100 90 L80 90 L80 110 L60 110 L60 90 L40 90 Z"
                stroke="#20bfd6"
                strokeWidth="4"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg></div>
        <div className="vh-hex h2"><svg className="vh-stroke-icon" width="140" height="140" viewBox="0 0 140 140">
              <path
                d="M40 70 L60 70 L60 50 L80 50 L80 70 L100 70 L100 90 L80 90 L80 110 L60 110 L60 90 L40 90 Z"
                stroke="#20bfd6"
                strokeWidth="4"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg></div>
        <div className="vh-hex h3"><svg className="vh-stroke-icon" width="140" height="140" viewBox="0 0 140 140">
              <path
                d="M40 70 L60 70 L60 50 L80 50 L80 70 L100 70 L100 90 L80 90 L80 110 L60 110 L60 90 L40 90 Z"
                stroke="#20bfd6"
                strokeWidth="4"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg></div>

        <div className="vh-container">

          {/* LEFT */}
          <div className="vh-left fadeUp">
            <h1 className="vh-title">
              Get Ready For Your <br />
              Best Ever <span className="highlight">Dental</span> Experience
            </h1>

            <p className="vh-desc">
              Lorem Ipsum is dummy text of the printing industry. Medical care
              with modern equipment and world-class doctors.
            </p>

           <div className="mh-cta-row">
              <button className="mh-btn primary btn-anim">Book Now</button>

              <div className="mh-play">
                <div className="play-circle-c8">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M8 5v14l11-7L8 5z" fill="#1a9fbf"/></svg>
                </div>
                <span className="play-text">See How We Work</span>
              </div></div>
          </div>

          {/* RIGHT */}
          <div className="vh-right">

            {/* Glow behind doctor */}
            <div className="vh-glow"></div>

            {/* Animated medical icon stroke */}
            <svg className="vh-stroke-icon" width="140" height="140" viewBox="0 0 140 140">
              <path
                d="M40 70 L60 70 L60 50 L80 50 L80 70 L100 70 L100 90 L80 90 L80 110 L60 110 L60 90 L40 90 Z"
                stroke="#20bfd6"
                strokeWidth="4"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>

            {/* Parallax portrait */}
            <div className="vh-portrait-wrap floatUp tilt">
              <img src={"https://i.postimg.cc/j5NkH2QB/female-doctor-hospital-with-stethoscope-removebg-preview.png"} className="vh-portrait" alt="doctor" />
<div  className="vh-portrait-wrap-two floatRight tilt">
              {/* Emergency badge */}
              <div className="vh-badge badge-em">
                <div className="bicon">📞</div>
                <div>
                  <div className="b-small">24 Hrs Emergency</div>
                  <div className="b-big">+12 1234567890</div>
                </div>
              </div>
</div>
              {/* Doctor badge */}
              <div  className="vh-portrait-wrap-three floatRight tilt">
              <div className="vh-badge badge-doc">
                <div className="bicon">🩺</div>
                <div>
                  <div className="b-small">24 Hrs Doctor</div>
                  <div className="b-big">Best Medical Service</div>
                </div>
              </div></div>

              {/* Patient Love badge */}
              <div className="vh-badge badge-love">
                <div className="b-big">1.5K Patient Love It ❤️</div>
                <div className="vh-avatars">
                  <img src="https://i.pravatar.cc/40?img=1" />
                  <img src="https://i.pravatar.cc/40?img=2" />
                  <img src="https://i.pravatar.cc/40?img=3" />
                  <img src="https://i.pravatar.cc/40?img=4" />
                </div>
              </div>
            </div>

            {/* Rotating ring-c8s */}
            <div className="vh-ring-c8 ring-c81"></div>
            <div className="vh-ring-c8 ring-c82"></div>

            {/* pulse dot-c8s */}
            <div className="dot-c8 d1"></div>
            <div className="dot-c8 d2"></div>
            <div className="dot-c8 d3"></div>

          </div>
        </div>

        {/* STATS BAR */}
        <div className="vh-stats">
          <div className="stat">
            ⭐ <strong>93%</strong>
            <span>Satisfaction Rate</span>
          </div>

          <div className="stat">
            👨‍⚕️ <strong>21+</strong>
            <span>Experts Doctors</span>
          </div>

          <div className="stat">
            ❤️ <strong>12K+</strong>
            <span>Happy Patients</span>
          </div>
        </div>

      </section>

      <style>{`
/* ------------------------------------------------------ */
/* BASE STRUCTURE */
/* ------------------------------------------------------ */
.vh-hero {
  background: #f0f9fc;
  padding: 90px 0 140px;
  position: relative;
  overflow: hidden;
  font-family: Inter, sans-serif;
}

.vh-container {
  width: 90%;
  max-width: 1300px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* CTA area */
.mh-cta-row { display:flex; align-items:center; gap:18px; flex-wrap:wrap; }

.mh-btn {
  background:#0b93a7;
  color:white;
  padding:12px 30px;
  border-radius:10px;
  border:none;
  font-weight:700;
  cursor:pointer;
  box-shadow: 0 10px 28px rgba(11,147,167,0.12);
}
.mh-btn.primary:hover { transform: translateY(-4px); transition: all .22s ease; }

.mh-play { display:flex; align-items:center; gap:12px; color:#0b93a7; cursor:pointer; }
.play-circle-c8 { width:46px; height:46px; border-radius:50%; background: #dff7fa; display:flex; align-items:center; justify-content:center; box-shadow: 0 6px 18px rgba(11,147,167,0.08); }

/* ------------------------------------------------------ */
/* HEX BACKGROUND */
/* ------------------------------------------------------ */
.vh-hex {
  width: 120px;
  height: 120px;
  background-size: contain;
  position: absolute;
  opacity: 0.22;
  animation: hexFloat 12s linear infinite;
}
.h1 { top: 80px; left: 60px; }
.h2 { top: 300px; left: -20px; animation-delay: 2s; }
.h3 { bottom: 120px; right: 80px; animation-delay: 4s; }

@keyframes hexFloat {
  0% { transform: translateY(0); opacity: .3 }
  50% { transform: translateY(-20px); opacity: .6 }
  100% { transform: translateY(0); opacity: .3 }
}

/* ------------------------------------------------------ */
/* LEFT */
/* ------------------------------------------------------ */
.vh-left {
  flex: 1.3;
}

.vh-title {
  font-size: 58px;
  font-weight: 800;
  line-height: 1.15;
  margin-bottom: 16px;
}
.highlight {
  color: #0da2b8;
  border-bottom: 4px solid #8cecf7;
}

.vh-desc {
  width: 80%;
  font-size: 18px;
  color: #455b67;
  margin-bottom: 26px;
  line-height: 1.6;
}

.vh-btn {
  background: #0eaac3;
  color: #fff;
  padding: 14px 34px;
  border-radius: 10px;
  border: none;
  font-size: 17px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 12px 30px rgba(14,160,180,0.25);
  transition: 0.25s;
}
.vh-btn:hover { transform: translateY(-6px); }

.vh-play {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
}
.play-circle-c8 {
  background: #dff9fc;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #0da2b8;
}

/* ------------------------------------------------------ */
/* RIGHT */
/* ------------------------------------------------------ */
.vh-right {
  position: relative;
  flex: 1;
  display: flex;
  justify-content: center;
}

/* Glow */
.vh-glow {
  width: 450px;
  height: 450px;
  border-radius: 50%;
  background: radial-gradient(circle-c8, rgba(14,180,200,0.5), rgba(14,180,200,0.1), transparent 70%);
  filter: blur(60px);
  position: absolute;
  top: 20px;
  z-index: 0;
  animation: pulseGlow 6s ease-in-out infinite;
}

@keyframes pulseGlow {
  0% { transform: scale(1); opacity: .7; }
  100% { transform: scale(1.12); opacity: 1; }
}

/* Portrait */
.vh-portrait-wrap {
  width: 320px;
  position: relative;margin-top:-50px;
  z-index: 5;
}.vh-portrait-wrap-two {
  width: 320px;
  position: absolute; top:30px;right:-50px;
  z-index: 5;
}.vh-portrait-wrap-three {
  width: 320px;
  position: absolute; bottom:30px;right:-50px;
  z-index: 5;
}
.vh-portrait {
  width: 100%;
  border-radius: 12px;
 
}

/* tilt */
.tilt:hover { transform: rotate3d(1,1,0,6deg); transition: 0.3s; }

/* floating */
.floatUp { animation: float 5s ease-in-out infinite; }
@keyframes float {
  0% { transform: translateY(0) }
  50% { transform: translateY(-12px) }
  100% { transform: translateY(0) }
}/* floating */
.floatRight { animation: floatR 5s ease-in-out infinite; }
@keyframes floatR {
  0% { transform: translateY(0) }
  50% { transform: translateX(-12px) }
  100% { transform: translateY(0) }
}


/* ------------------------------------------------------ */
/* BADGES */
/* ------------------------------------------------------ */
.vh-badge {
  position: absolute;
  background: #fff;
  padding: 12px 16px;
  border-radius: 12px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.12);
  display: flex;
  gap: 12px;
}

.bicon {
  background: #e7faff;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.badge-em { top: 20px; right: -60px; }
.badge-doc { bottom: -20px; right: -50px; }
.badge-love {
  bottom: 120px;
  left: -50px;
  flex-direction: column;
}
.vh-avatars img { width: 32px; height: 32px; border-radius: 50%; }

/* ------------------------------------------------------ */
/* RINGS */
/* ------------------------------------------------------ */
.vh-ring-c8 {
  position: absolute;
  border-radius: 50%;
  border: 2px solid rgba(14,180,200,0.18);
}
.ring-c81 {
  width: 420px;
  height: 420px;
  top: 0;
  animation: spin 22s linear infinite;
}
.ring-c82 {
  width: 320px;
  height: 320px;
  top: 50px;
  border-style: dashed;
  animation: spinReverse 16s linear infinite;
}

@keyframes spin { to { transform: rotate(360deg); } }
@keyframes spinReverse { to { transform: rotate(-360deg); } }

/* ------------------------------------------------------ */
/* MEDICAL ICON STROKE */
/* ------------------------------------------------------ */
.vh-stroke-icon {
  position: absolute;
  left: 0;
  top: -20px;
  opacity: .4;
  width: 140px;
}

.vh-stroke-icon path {
  stroke-dasharray: 300;
  stroke-dashoffset: 300;
  animation: draw 3s ease forwards;
}

@keyframes draw { to { stroke-dashoffset: 0; } }

/* ------------------------------------------------------ */
/* PULSE DOTS */
/* ------------------------------------------------------ */
.dot-c8 {
  width: 14px;
  height: 14px;
  background: #bdf1f7;
  border-radius: 50%;
  position: absolute;
  animation: pulse 3s ease-in-out infinite;
}
.d1 { top: 20px; right: 40px; }
.d2 { bottom: 120px; right: 90px; animation-delay: .5s; }
.d3 { bottom: 60px; left: -20px; animation-delay: 1s; }

@keyframes pulse {
  0% { transform: scale(.8); opacity:.4 }
  50% { transform: scale(1.4); opacity: .7 }
  100% { transform: scale(.8); opacity:.4 }
}

/* ------------------------------------------------------ */
/* STATS BAR */
/* ------------------------------------------------------ */
.vh-stats {
  margin-top: 70px;
  background: #fff;
  padding: 22px 40px;
  border-radius: 16px;
  width: 88%;
  max-width: 1150px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: space-between;
  box-shadow: 0 20px 40px rgba(0,0,0,0.1);
}
.stat {
  text-align:center;
  font-size: 16px;
}
.stat strong {
  display:block;
  font-size: 30px;
  margin-top: 6px;
}

/* ------------------------------------------------------ */
/* ANIMATION ENTRY */
/* ------------------------------------------------------ */
.fadeUp {
  opacity: 0;
  animation: fadeUpA .8s ease forwards;
}
@keyframes fadeUpA {
  0% {opacity:0; transform: translateY(20px);}
  100% {opacity:1; transform: translateY(0);}
}

      `}</style>
    </>
  );
}
